import { memo, useEffect, useRef } from "react";

import { Box } from "@mui/material";

import { useBszPlannerContext } from "../../context/bszPlannerContext";

import BszSectionCard from "../../../1_BSZFinderApp/components/sectionCards/BszSectionCard";

import usePlannerTimelineData from "./hooks/usePlannerTimelineData";

import {
  CELL_GAP,
  CELL_SIZE,
  LABEL_WIDTH,
} from "./constants/timelineConstants";
import { useAppContext } from "../../../../2_ksbHub/context/appContext";
import TimelineRow from "./components/TimelineRow";
import TimelineHeader from "./TimelineHeader";
import PlannerTimelineHelpMessage from "./PlannerTimelineHelpMessage";

function PlannerProjectTimelineSection({ dialogs }) {
  const {
    projects = [],
    subjects = [],
    selectedClass = null,
  } = useBszPlannerContext();

  const { currentUser, isATeacher, isStudentView } = useAppContext();

  const { weeks, holidayWeeks, subjectRows, currentWeekIndex } =
    usePlannerTimelineData({
      projects,
      subjects,
      isTeacher: isATeacher && !isStudentView,
      selectedClass,
    });

  const timelineScrollRef = useRef(null);

  /**
   * =========================================================
   * ✅ AUTO SCROLL TO CURRENT WEEK
   * =========================================================
   */
  useEffect(() => {
    if (!timelineScrollRef.current) {
      return;
    }

    if (currentWeekIndex < 0) {
      return;
    }

    timelineScrollRef.current.scrollLeft = Math.max(
      0,
      (currentWeekIndex - 4) * (CELL_SIZE + CELL_GAP),
    );
  }, [currentWeekIndex]);

  const myProjects = projects.filter(
    (project) => project.teacherId === currentUser.id,
  );

  const shouldShowHelp = isATeacher && !isStudentView && myProjects.length < 3;

  /**
   * =========================================================
   * ✅ RENDER
   * =========================================================
   */
  return (
    <BszSectionCard title="Projekt-Timeline" defaultExpanded>
      {shouldShowHelp && <PlannerTimelineHelpMessage />}
      <Box
        ref={timelineScrollRef}
        sx={{
          height: 500,
          overflow: "auto",

          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE/Edge

          "&::-webkit-scrollbar": {
            display: "none", // Chrome/Safari
          },
        }}
      >
        <Box
          sx={{
            width: LABEL_WIDTH + weeks.length * (CELL_SIZE + CELL_GAP),
          }}
        >
          <TimelineHeader weeks={weeks} holidayWeeks={holidayWeeks} />

          {/* ===========================================
            SUBJECT ROWS
        =========================================== */}

          {subjectRows.map((row) => (
            <TimelineRow
              key={row.subjectName}
              row={row}
              weeks={weeks}
              holidayWeeks={holidayWeeks}
              dialogs={dialogs}
            />
          ))}
        </Box>
      </Box>
    </BszSectionCard>
  );
}

export default memo(PlannerProjectTimelineSection);
